import { CWBaseModel } from 'core/models/cwBase.model';

export class CWCalendaccElementsModel extends CWBaseModel {

  constructor(attributes?: { [key: string]: any }, options?: { [key: string]: any }) {
    CWCalendaccElementsModel.prototype.idAttribute = "date";
    super(attributes, options);
  }
}